import { P00039DataRxTxIndex } from '../../../P00039Sync';

import { P00032 } from '../../../P00032';
import { getPoolMasterClass } from '../../../../../ECoSystemsHelper';
import { P0003600 } from '../../../P0003600';
import { P0004700 } from '../../../P0004700';
import { P00046 } from '../../../P00046';
import { IProduct } from '../../../../IProduct';
import { P0003601 } from '../../../P0003601';
import { P00058 } from '../../../P00058';
import { P0006600 } from '../../../P0006600';
import { Pool, PoolAdditionalData } from '../../../../../../../apis/pool.api';

export function P00080AltimeoMiseEnOeuvreInit(
  pool: Pool,
  productClass: IProduct,
  editValue: any,
  getValue: any,
  additionalData: PoolAdditionalData,
) {
  const master = getPoolMasterClass(pool);

  let force = false;

  let produitP00032 = master?.hasProduct(pool, new P00032()) ?? 0;
  if (getValue('snIInstallationCapteurDebit', new P00032()) !== 1) {
    produitP00032 = 0;
  }

  const produitP0003600 = master?.hasProduct(pool, new P0003600()) ?? 0;
  const produitP0004700 = master?.hasProduct(pool, new P0004700()) ?? 0;
  const produitP00046 = master?.hasProduct(pool, new P00046()) ?? 0;
  const produitP0003601 = master?.hasProduct(pool, new P0003601()) ?? 0;
  const produitP00058 = master?.hasProduct(pool, new P00058()) ?? 0;
  const produitP0006600 = master?.hasProduct(pool, new P0006600()) ?? 0;

  const getSourceDebit = (
    PP00046: any,
    PP0003601: any,
    PP00032: any,
    PP0003600: any,
    PP0004700: any,
    PP00058: any,
    PP0006600: any,
    injection: any,
    detecteur: any,
  ) => {
    if (
      PP00046 === 0 &&
      PP0003601 === 0 &&
      PP00032 === 0 &&
      PP0003600 === 0 &&
      PP0004700 === 0 &&
      injection === 0 &&
      detecteur === 0 &&
      PP00058 === 0 &&
      PP0006600 === 0
    ) {
      return { default: 0, choixUser: [0] };
    }
    if (
      PP00046 === 0 &&
      PP0003601 === 0 &&
      PP00032 === 0 &&
      PP0003600 === 0 &&
      PP0004700 === 0 &&
      injection === 0 &&
      detecteur === 1 &&
      PP00058 === 0 &&
      PP0006600 === 0
    ) {
      return { default: 0, choixUser: [0] };
    }
    if (
      PP00046 === 0 &&
      PP0003601 === 0 &&
      PP00032 === 0 &&
      PP0003600 === 0 &&
      PP0004700 === 0 &&
      injection === 1 &&
      detecteur === 0 &&
      PP00058 === 0 &&
      PP0006600 === 0
    ) {
      return { default: 0, choixUser: [0] };
    }
    if (
      PP00046 === 0 &&
      PP0003601 === 0 &&
      PP00032 === 0 &&
      PP0003600 === 0 &&
      PP0004700 === 0 &&
      injection === 1 &&
      detecteur === 1 &&
      PP00058 === 0 &&
      PP0006600 === 0
    ) {
      return { default: 0, choixUser: [0] };
    }

    if (
      PP00046 === 0 &&
      PP0003601 === 0 &&
      PP00032 === 0 &&
      (PP0003600 > 0 || PP0004700 > 0) &&
      injection === 0 &&
      detecteur === 0 &&
      PP00058 === 0 &&
      PP0006600 === 0
    ) {
      return { default: 2, choixUser: [2] };
    }
    if (
      PP00046 === 0 &&
      PP0003601 === 0 &&
      PP00032 === 0 &&
      (PP0003600 > 0 || PP0004700 > 0) &&
      injection === 0 &&
      detecteur === 1 &&
      PP00058 === 0 &&
      PP0006600 === 0
    ) {
      return { default: 2, choixUser: [2] };
    }
    if (
      PP00046 === 0 &&
      PP0003601 === 0 &&
      PP00032 === 0 &&
      (PP0003600 > 0 || PP0004700 > 0) &&
      injection === 1 &&
      detecteur === 0 &&
      PP00058 === 0 &&
      PP0006600 === 0
    ) {
      return { default: 2, choixUser: [2] };
    }
    if (
      PP00046 === 0 &&
      PP0003601 === 0 &&
      PP00032 === 0 &&
      (PP0003600 > 0 || PP0004700 > 0) &&
      injection === 1 &&
      detecteur === 1 &&
      PP00058 === 0 &&
      PP0006600 === 0
    ) {
      return { default: 2, choixUser: [2] };
    }

    if (
      PP00046 === 0 &&
      PP0003601 === 0 &&
      PP00032 > 0 &&
      PP0003600 === 0 &&
      PP0004700 === 0 &&
      injection === 0 &&
      detecteur === 0 &&
      PP00058 === 0 &&
      PP0006600 === 0
    ) {
      return { default: 1, choixUser: [1] };
    }
    if (
      PP00046 === 0 &&
      PP0003601 === 0 &&
      PP00032 > 0 &&
      PP0003600 === 0 &&
      PP0004700 === 0 &&
      injection === 0 &&
      detecteur === 1 &&
      PP00058 === 0 &&
      PP0006600 === 0
    ) {
      return { default: 1, choixUser: [1] };
    }
    if (
      PP00046 === 0 &&
      PP0003601 === 0 &&
      PP00032 > 0 &&
      PP0003600 === 0 &&
      PP0004700 === 0 &&
      injection === 1 &&
      detecteur === 0 &&
      PP00058 === 0 &&
      PP0006600 === 0
    ) {
      return { default: 1, choixUser: [1] };
    }
    if (
      PP00046 === 0 &&
      PP0003601 === 0 &&
      PP00032 > 0 &&
      PP0003600 === 0 &&
      PP0004700 === 0 &&
      injection === 1 &&
      detecteur === 1 &&
      PP00058 === 0 &&
      PP0006600 === 0
    ) {
      return { default: 1, choixUser: [1] };
    }

    if (
      PP00046 === 0 &&
      PP0003601 === 0 &&
      PP00032 > 0 &&
      (PP0003600 > 0 || PP0004700 > 0) &&
      injection === 0 &&
      detecteur === 0 &&
      PP00058 === 0 &&
      PP0006600 === 0
    ) {
      return { default: 1, choixUser: [1, 2] };
    }
    if (
      PP00046 === 0 &&
      PP0003601 === 0 &&
      PP00032 > 0 &&
      (PP0003600 > 0 || PP0004700 > 0) &&
      injection === 0 &&
      detecteur === 1 &&
      PP00058 === 0 &&
      PP0006600 === 0
    ) {
      return { default: 2, choixUser: [1, 2] };
    }
    if (
      PP00046 === 0 &&
      PP0003601 === 0 &&
      PP00032 > 0 &&
      (PP0003600 > 0 || PP0004700 > 0) &&
      injection === 1 &&
      detecteur === 0 &&
      PP00058 === 0 &&
      PP0006600 === 0
    ) {
      return { default: 1, choixUser: [1, 2] };
    }
    if (
      PP00046 === 0 &&
      PP0003601 === 0 &&
      PP00032 > 0 &&
      (PP0003600 > 0 || PP0004700 > 0) &&
      injection === 1 &&
      detecteur === 1 &&
      PP00058 === 0 &&
      PP0006600 === 0
    ) {
      return { default: 1, choixUser: [1, 2] };
    }

    if (
      (PP00046 > 0 || PP0003601 > 0) &&
      PP00032 === 0 &&
      PP0003600 === 0 &&
      PP0004700 === 0 &&
      injection === 0 &&
      detecteur === 0 &&
      PP00058 === 0 &&
      PP0006600 === 0
    ) {
      return { default: 3, choixUser: [3] };
    }
    if (
      (PP00046 > 0 || PP0003601 > 0) &&
      PP00032 === 0 &&
      PP0003600 === 0 &&
      PP0004700 === 0 &&
      injection === 0 &&
      detecteur === 1 &&
      PP00058 === 0 &&
      PP0006600 === 0
    ) {
      return { default: 3, choixUser: [3] };
    }
    if (
      (PP00046 > 0 || PP0003601 > 0) &&
      PP00032 === 0 &&
      PP0003600 === 0 &&
      PP0004700 === 0 &&
      injection === 1 &&
      detecteur === 0 &&
      PP00058 === 0 &&
      PP0006600 === 0
    ) {
      return { default: 3, choixUser: [3] };
    }
    if (
      (PP00046 > 0 || PP0003601 > 0) &&
      PP00032 === 0 &&
      PP0003600 === 0 &&
      PP0004700 === 0 &&
      injection === 1 &&
      detecteur === 1 &&
      PP00058 === 0 &&
      PP0006600 === 0
    ) {
      return { default: 3, choixUser: [3] };
    }

    if (
      (PP00046 > 0 || PP0003601 > 0) &&
      PP00032 === 0 &&
      (PP0003600 > 0 || PP0004700 > 0) &&
      injection === 0 &&
      detecteur === 0 &&
      PP00058 === 0 &&
      PP0006600 === 0
    ) {
      return { default: 2, choixUser: [2] };
    }
    if (
      (PP00046 > 0 || PP0003601 > 0) &&
      PP00032 === 0 &&
      (PP0003600 > 0 || PP0004700 > 0) &&
      injection === 0 &&
      detecteur === 1 &&
      PP00058 === 0 &&
      PP0006600 === 0
    ) {
      return { default: 2, choixUser: [2] };
    }
    if (
      (PP00046 > 0 || PP0003601 > 0) &&
      PP00032 === 0 &&
      (PP0003600 > 0 || PP0004700 > 0) &&
      injection === 1 &&
      detecteur === 0 &&
      PP00058 === 0 &&
      PP0006600 === 0
    ) {
      return { default: 2, choixUser: [2] };
    }
    if (
      (PP00046 > 0 || PP0003601 > 0) &&
      PP00032 === 0 &&
      (PP0003600 > 0 || PP0004700 > 0) &&
      injection === 1 &&
      detecteur === 1 &&
      PP00058 === 0 &&
      PP0006600 === 0
    ) {
      return { default: 2, choixUser: [2] };
    }

    if (
      (PP00046 > 0 || PP0003601 > 0) &&
      PP00032 > 0 &&
      PP0003600 === 0 &&
      PP0004700 === 0 &&
      injection === 0 &&
      detecteur === 0 &&
      PP00058 === 0 &&
      PP0006600 === 0
    ) {
      return { default: 1, choixUser: [1, 3] };
    }
    if (
      (PP00046 > 0 || PP0003601 > 0) &&
      PP00032 > 0 &&
      PP0003600 === 0 &&
      PP0004700 === 0 &&
      injection === 0 &&
      detecteur === 1 &&
      PP00058 === 0 &&
      PP0006600 === 0
    ) {
      return { default: 3, choixUser: [1, 3] };
    }
    if (
      (PP00046 > 0 || PP0003601 > 0) &&
      PP00032 > 0 &&
      PP0003600 === 0 &&
      PP0004700 === 0 &&
      injection === 1 &&
      detecteur === 0 &&
      PP00058 === 0 &&
      PP0006600 === 0
    ) {
      return { default: 1, choixUser: [1, 3] };
    }
    if (
      (PP00046 > 0 || PP0003601 > 0) &&
      PP00032 > 0 &&
      PP0003600 === 0 &&
      PP0004700 === 0 &&
      injection === 1 &&
      detecteur === 1 &&
      PP00058 === 0 &&
      PP0006600 === 0
    ) {
      return { default: 1, choixUser: [1, 3] };
    }

    if (
      (PP00046 > 0 || PP0003601 > 0) &&
      PP00032 > 0 &&
      (PP0003600 > 0 || PP0004700 > 0) &&
      injection === 0 &&
      detecteur === 0 &&
      PP00058 === 0 &&
      PP0006600 === 0
    ) {
      return { default: 1, choixUser: [1, 2] };
    }
    if (
      (PP00046 > 0 || PP0003601 > 0) &&
      PP00032 > 0 &&
      (PP0003600 > 0 || PP0004700 > 0) &&
      injection === 0 &&
      detecteur === 1 &&
      PP00058 === 0 &&
      PP0006600 === 0
    ) {
      return { default: 2, choixUser: [1, 2] };
    }
    if (
      (PP00046 > 0 || PP0003601 > 0) &&
      PP00032 > 0 &&
      (PP0003600 > 0 || PP0004700 > 0) &&
      injection === 1 &&
      detecteur === 0 &&
      PP00058 === 0 &&
      PP0006600 === 0
    ) {
      return { default: 1, choixUser: [1, 2] };
    }
    if (
      (PP00046 > 0 || PP0003601 > 0) &&
      PP00032 > 0 &&
      (PP0003600 > 0 || PP0004700 > 0) &&
      injection === 1 &&
      detecteur === 1 &&
      PP00058 === 0 &&
      PP0006600 === 0
    ) {
      return { default: 1, choixUser: [1, 2] };
    }

    if (
      PP00046 === 0 &&
      PP0003601 === 0 &&
      PP00032 === 0 &&
      PP0003600 === 0 &&
      PP0004700 === 0 &&
      injection === 0 &&
      detecteur === 0 &&
      (PP00058 > 0 || PP0006600 > 0)
    ) {
      return { default: 4, choixUser: [4] };
    }
    if (
      PP00046 === 0 &&
      PP0003601 === 0 &&
      PP00032 === 0 &&
      PP0003600 === 0 &&
      PP0004700 === 0 &&
      injection === 0 &&
      detecteur === 1 &&
      (PP00058 > 0 || PP0006600 > 0)
    ) {
      return { default: 4, choixUser: [4] };
    }
    if (
      PP00046 === 0 &&
      PP0003601 === 0 &&
      PP00032 === 0 &&
      PP0003600 === 0 &&
      PP0004700 === 0 &&
      injection === 1 &&
      detecteur === 0 &&
      (PP00058 > 0 || PP0006600 > 0)
    ) {
      return { default: 4, choixUser: [4] };
    }
    if (
      PP00046 === 0 &&
      PP0003601 === 0 &&
      PP00032 === 0 &&
      PP0003600 === 0 &&
      PP0004700 === 0 &&
      injection === 1 &&
      detecteur === 1 &&
      (PP00058 > 0 || PP0006600 > 0)
    ) {
      return { default: 4, choixUser: [4] };
    }

    if (
      (PP00046 > 0 || PP0003601 > 0) &&
      PP00032 === 0 &&
      PP0003600 === 0 &&
      PP0004700 === 0 &&
      injection === 0 &&
      detecteur === 0 &&
      (PP00058 > 0 || PP0006600 > 0)
    ) {
      return { default: 3, choixUser: [3] };
    }
    if (
      (PP00046 > 0 || PP0003601 > 0) &&
      PP00032 === 0 &&
      PP0003600 === 0 &&
      PP0004700 === 0 &&
      injection === 0 &&
      detecteur === 1 &&
      (PP00058 > 0 || PP0006600 > 0)
    ) {
      return { default: 3, choixUser: [3] };
    }
    if (
      (PP00046 > 0 || PP0003601 > 0) &&
      PP00032 === 0 &&
      PP0003600 === 0 &&
      PP0004700 === 0 &&
      injection === 1 &&
      detecteur === 0 &&
      (PP00058 > 0 || PP0006600 > 0)
    ) {
      return { default: 3, choixUser: [3] };
    }
    if (
      (PP00046 > 0 || PP0003601 > 0) &&
      PP00032 === 0 &&
      PP0003600 === 0 &&
      PP0004700 === 0 &&
      injection === 1 &&
      detecteur === 1 &&
      (PP00058 > 0 || PP0006600 > 0)
    ) {
      return { default: 3, choixUser: [3] };
    }

    if (
      PP00046 === 0 &&
      PP0003601 === 0 &&
      PP00032 > 0 &&
      PP0003600 === 0 &&
      PP0004700 === 0 &&
      injection === 0 &&
      detecteur === 0 &&
      (PP00058 > 0 || PP0006600 > 0)
    ) {
      return { default: 1, choixUser: [1, 4] };
    }
    if (
      PP00046 === 0 &&
      PP0003601 === 0 &&
      PP00032 > 0 &&
      PP0003600 === 0 &&
      PP0004700 === 0 &&
      injection === 0 &&
      detecteur === 1 &&
      (PP00058 > 0 || PP0006600 > 0)
    ) {
      return { default: 4, choixUser: [1, 4] };
    }
    if (
      PP00046 === 0 &&
      PP0003601 === 0 &&
      PP00032 > 0 &&
      PP0003600 === 0 &&
      PP0004700 === 0 &&
      injection === 1 &&
      detecteur === 0 &&
      (PP00058 > 0 || PP0006600 > 0)
    ) {
      return { default: 1, choixUser: [1, 4] };
    }
    if (
      PP00046 === 0 &&
      PP0003601 === 0 &&
      PP00032 > 0 &&
      PP0003600 === 0 &&
      PP0004700 === 0 &&
      injection === 1 &&
      detecteur === 1 &&
      (PP00058 > 0 || PP0006600 > 0)
    ) {
      return { default: 1, choixUser: [1, 4] };
    }

    if (
      PP00046 === 0 &&
      PP0003601 === 0 &&
      PP00032 === 0 &&
      (PP0003600 > 0 || PP0004700 > 0) &&
      injection === 0 &&
      detecteur === 0 &&
      (PP00058 > 0 || PP0006600 > 0)
    ) {
      return { default: 2, choixUser: [2] };
    }
    if (
      PP00046 === 0 &&
      PP0003601 === 0 &&
      PP00032 === 0 &&
      (PP0003600 > 0 || PP0004700 > 0) &&
      injection === 0 &&
      detecteur === 1 &&
      (PP00058 > 0 || PP0006600 > 0)
    ) {
      return { default: 2, choixUser: [2] };
    }
    if (
      PP00046 === 0 &&
      PP0003601 === 0 &&
      PP00032 === 0 &&
      (PP0003600 > 0 || PP0004700 > 0) &&
      injection === 1 &&
      detecteur === 0 &&
      (PP00058 > 0 || PP0006600 > 0)
    ) {
      return { default: 2, choixUser: [2] };
    }
    if (
      PP00046 === 0 &&
      PP0003601 === 0 &&
      PP00032 === 0 &&
      (PP0003600 > 0 || PP0004700 > 0) &&
      injection === 1 &&
      detecteur === 1 &&
      (PP00058 > 0 || PP0006600 > 0)
    ) {
      return { default: 2, choixUser: [2] };
    }

    if (
      (PP00046 > 0 || PP0003601 > 0) &&
      PP00032 > 0 &&
      PP0003600 === 0 &&
      PP0004700 === 0 &&
      injection === 0 &&
      detecteur === 0 &&
      (PP00058 > 0 || PP0006600 > 0)
    ) {
      return { default: 1, choixUser: [1] };
    }
    if (
      (PP00046 > 0 || PP0003601 > 0) &&
      PP00032 > 0 &&
      PP0003600 === 0 &&
      PP0004700 === 0 &&
      injection === 0 &&
      detecteur === 1 &&
      (PP00058 > 0 || PP0006600 > 0)
    ) {
      return { default: 1, choixUser: [1] };
    }
    if (
      (PP00046 > 0 || PP0003601 > 0) &&
      PP00032 > 0 &&
      PP0003600 === 0 &&
      PP0004700 === 0 &&
      injection === 1 &&
      detecteur === 0 &&
      (PP00058 > 0 || PP0006600 > 0)
    ) {
      return { default: 1, choixUser: [1] };
    }
    if (
      (PP00046 > 0 || PP0003601 > 0) &&
      PP00032 > 0 &&
      PP0003600 === 0 &&
      PP0004700 === 0 &&
      injection === 1 &&
      detecteur === 1 &&
      (PP00058 > 0 || PP0006600 > 0)
    ) {
      return { default: 1, choixUser: [1] };
    }

    if (
      (PP00046 > 0 || PP0003601 > 0) &&
      PP00032 === 0 &&
      (PP0003600 > 0 || PP0004700 > 0) &&
      injection === 0 &&
      detecteur === 0 &&
      (PP00058 > 0 || PP0006600 > 0)
    ) {
      return { default: 2, choixUser: [2] };
    }
    if (
      (PP00046 > 0 || PP0003601 > 0) &&
      PP00032 === 0 &&
      (PP0003600 > 0 || PP0004700 > 0) &&
      injection === 0 &&
      detecteur === 1 &&
      (PP00058 > 0 || PP0006600 > 0)
    ) {
      return { default: 2, choixUser: [2] };
    }
    if (
      (PP00046 > 0 || PP0003601 > 0) &&
      PP00032 === 0 &&
      (PP0003600 > 0 || PP0004700 > 0) &&
      injection === 1 &&
      detecteur === 0 &&
      (PP00058 > 0 || PP0006600 > 0)
    ) {
      return { default: 2, choixUser: [2] };
    }
    if (
      (PP00046 > 0 || PP0003601 > 0) &&
      PP00032 === 0 &&
      (PP0003600 > 0 || PP0004700 > 0) &&
      injection === 1 &&
      detecteur === 1 &&
      (PP00058 > 0 || PP0006600 > 0)
    ) {
      return { default: 2, choixUser: [2] };
    }

    if (
      PP00046 === 0 &&
      PP0003601 === 0 &&
      PP00032 > 0 &&
      (PP0003600 > 0 || PP0004700 > 0) &&
      injection === 0 &&
      detecteur === 0 &&
      (PP00058 > 0 || PP0006600 > 0)
    ) {
      return { default: 1, choixUser: [1] };
    }
    if (
      PP00046 === 0 &&
      PP0003601 === 0 &&
      PP00032 > 0 &&
      (PP0003600 > 0 || PP0004700 > 0) &&
      injection === 0 &&
      detecteur === 1 &&
      (PP00058 > 0 || PP0006600 > 0)
    ) {
      return { default: 1, choixUser: [1] };
    }
    if (
      PP00046 === 0 &&
      PP0003601 === 0 &&
      PP00032 > 0 &&
      (PP0003600 > 0 || PP0004700 > 0) &&
      injection === 1 &&
      detecteur === 0 &&
      (PP00058 > 0 || PP0006600 > 0)
    ) {
      return { default: 1, choixUser: [1] };
    }
    if (
      PP00046 === 0 &&
      PP0003601 === 0 &&
      PP00032 > 0 &&
      (PP0003600 > 0 || PP0004700 > 0) &&
      injection === 1 &&
      detecteur === 1 &&
      (PP00058 > 0 || PP0006600 > 0)
    ) {
      return { default: 1, choixUser: [1] };
    }

    if (
      (PP00046 > 0 || PP0003601 > 0) &&
      PP00032 > 0 &&
      (PP0003600 > 0 || PP0004700 > 0) &&
      injection === 0 &&
      detecteur === 0 &&
      (PP00058 > 0 || PP0006600 > 0)
    ) {
      return { default: 1, choixUser: [1] };
    }
    if (
      (PP00046 > 0 || PP0003601 > 0) &&
      PP00032 > 0 &&
      (PP0003600 > 0 || PP0004700 > 0) &&
      injection === 0 &&
      detecteur === 1 &&
      (PP00058 > 0 || PP0006600 > 0)
    ) {
      return { default: 1, choixUser: [1] };
    }
    if (
      (PP00046 > 0 || PP0003601 > 0) &&
      PP00032 > 0 &&
      (PP0003600 > 0 || PP0004700 > 0) &&
      injection === 1 &&
      detecteur === 0 &&
      (PP00058 > 0 || PP0006600 > 0)
    ) {
      return { default: 1, choixUser: [1] };
    }
    if (
      (PP00046 > 0 || PP0003601 > 0) &&
      PP00032 > 0 &&
      (PP0003600 > 0 || PP0004700 > 0) &&
      injection === 1 &&
      detecteur === 1 &&
      (PP00058 > 0 || PP0006600 > 0)
    ) {
      return { default: 1, choixUser: [1] };
    }

    return null;
  };

  const sourceReferenceDebit = getSourceDebit(
    produitP00046,
    produitP0003601,
    produitP00032,
    produitP0003600,
    produitP0004700,
    produitP00058,
    produitP0006600,
    additionalData.alPositionInjection ?? 0,
    additionalData.positionDetecteurDebit ?? 0,
  );

  const currentSourceReferenceDebit = getValue(
    'alISourceReferenceDebit',
    productClass,
  );

  if (
    sourceReferenceDebit &&
    sourceReferenceDebit.choixUser.indexOf(currentSourceReferenceDebit) == -1
  ) {
    editValue(
      P00039DataRxTxIndex.Altimeo_Installation,
      'alISourceReferenceDebit',
      sourceReferenceDebit.default,
      null,
      productClass,
    );

    if (sourceReferenceDebit && sourceReferenceDebit.choixUser.length > 1) {
      force = true;
    }
  }

  return force;
}
